import { consola } from 'consola'
import { useLogoutHandler } from '~/features/auth/model'

// Logger
const logger = consola.withTag('profile-auth-middleware')

/**
 * Middleware для защиты профильных маршрутов
 * 
 * ✅ Проверяет авторизацию пользователя
 * ✅ Использует V2 систему (HttpOnly refresh token)
 * ✅ Предотвращает доступ к защищенным страницам без авторизации
 */
export default defineNuxtRouteMiddleware(async (to, _from) => {
  // Выполняется только на клиенте
  if (!process.client) return
  
  const logoutHandler = useLogoutHandler()
  const authStore = useAuthStore()
  
  if (process.dev) {
    logger.debug('Проверка доступа к профильному маршруту:', {
      path: to.path,
      isRefreshTokenInvalid: logoutHandler.isRefreshTokenInvalid(),
      isLoggedIn: authStore.isLoggedIn,
    })
  }
  
  // Предотвращение рекурсии - если уже на главной странице
  if (to.path === '/') {
    logger.debug('Уже на главной странице, пропускаем проверку')
    return
  }
  
  // СТРОГАЯ ПРОВЕРКА: Редирект неавторизованных пользователей
  if (!authStore.isLoggedIn) {
    logger.warn('Пользователь не авторизован, перенаправление на главную')
    return navigateTo('/', { replace: true })
  }
  
  // Проверка валидности refresh token
  if (logoutHandler.isRefreshTokenInvalid()) {
    logger.warn('Refresh token недействителен, перенаправление на главную')
    return navigateTo('/', { replace: true })
  }
  
  logger.success('Доступ к профильному маршруту разрешен')
}) 